import React, { useState } from 'react';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { FileUploader } from 'react-drag-drop-files';
import { wsCreate } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import { wsRemove } from 'services/WService';

const fileTypes = ['JPG', 'PNG'];

function CustomerPhotoModal(props) {
  const { model, setOpen, showNotify } = props;
  const { setCustomer } = props;
  const [processing, setProcessing] = useState(false);

  async function deletePhoto() {
    setProcessing(true);
    let res = await wsRemove(`base/address/${model.base_address_id}/photo`, model.LineNum);
    if (res.success) {
      setCustomer((customer) => {
        let newAddress = { ...customer };
        newAddress.photos_address = res.data;
        return newAddress;
      });
      setProcessing(false);
      setOpen({ open: false });
    } else {
      setProcessing(false);
      showNotify(res.message, 'error');
    }
  }

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      hideSave
      maxWidth="sm"
      title={
        model.id === undefined
          ? 'Nueva foto'
          : `${model.LineNum} - ${model.business_name} - ${model.base_address_description}`
      }
    >
      {model.file_url !== undefined && model.file_url !== null && processing === false && (
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            minHeight: '200px',
            overflow: 'hidden',
            marginBottom: '20px',
          }}
        >
          <img src={model.file_url} style={{ width: '100%' }} />
        </div>
      )}

      {processing && (
        <div style={{ width: '350px', height: '200px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ alignSelf: 'center', width: '60px', height: '60px', marginTop: '45px' }}>
            <div className="lds-dual-ring"></div>
          </div>
        </div>
      )}

      {model.id !== undefined && model.file_url !== null && (
        <RegularButton color="danger" fullWidth onClick={deletePhoto} disabled={processing}>
          Eliminar
        </RegularButton>
      )}
    </ModalBase>
  );
}

export default CustomerPhotoModal;
